//---------------------------------Generales
function anclaanimada() {
  //redirigir anclas de forma animada
  $(".scroll").on('click', function (e) {
    e.preventDefault();
    var codigo = $(this).attr("href");
    $("html,body").animate({scrollTop: $(codigo).offset().top}, 600);
  });
}

function togglemenu() {
  if ($(window).width() < 1200) {
    $('header .navbar-toggler').on('click', function () {
      $('body').toggleClass('header-active');
    });
  }
}

//---------------------------------Slides

function redirect(){
    if(window.location.hash == '#construccion-en-tiempo-real'){
      $('#nav-indice-construccion-tab').tab('show');
      killHash();
    }
    if(window.location.hash == '#comportamiento-de-las-ventas'){
      $('#nav-comportamiento-ventas-tab').tab('show');
      killHash();
    }
    if(window.location.hash == '#radiografia-del-mercado'){
      $('#nav-radiografia-tab').tab('show');
      killHash();
    }
}

function sliderImgPropiedades(){
  sliderSwiper('.sliderImgPropiedades', 'horizontal', 1, 3, false);
}

//---------------------------------Template de Slides func (class del div., horiz o vert., slidesperview, slide to click slide, breackpoints)
function sliderSwiper(DivSwiper, direction, spv, space, dynaBul){
  var swiper = new Swiper(DivSwiper + '  .swiper-container', {
    direction: direction,
    slidesPerView: spv,
    spaceBetween: space,
    play: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: DivSwiper + ' .swiper-button-next',
      prevEl: DivSwiper + ' .swiper-button-prev',
    },
    grabCursor: true,
    pagination: {
      el: DivSwiper + '  .swiper-pagination',
      dynamicBullets: dynaBul,
      clickable: true
    }
  });


  if($(DivSwiper + " .swiper-slide").length == 1) {
    $(DivSwiper + " .swiper-pagination").addClass( "disabled" );
  }
}


function killHash(){
  const hash = window.location.hash;
  history.scrollRestoration = 'manual';
  window.location.href = hash;
  history.pushState('', document.title, window.location.pathname);
}

/*jQuery Global Functions*/
$(document).ready(function () {
  togglemenu();
  anclaanimada();
  redirect();
  sliderImgPropiedades();
});
